var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('b-tooltip',{attrs:{"label":"Sync to iRebal","position":"is-bottom"}},[_c('b-button',{attrs:{"label":"iRebal","type":"is-primary","size":"is-small","icon-pack":"fas","icon-left":"cloud-upload-alt","loading":_vm.in_progress_one,"outlined":""},on:{"click":_vm.syncPortfolio}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }